<template>
  <div>
    <head-nav-bar :title="type == 3 ? '办理暂离' : '办理退房'" :fixed="true" />
    <div class="mt-header-nav">
      <van-row style="font-size: 14px;">
        <van-col span="12" style="color: #999999;">房间列表</van-col>
        <van-col span="12" class="allSelect" @click="hanldeSelectRoom">
          <span>全选 </span>
          <van-switch
            v-model="checked"
            style=" vertical-align: -3px;"
            size="16px"
            active-color="#07c160"
            inactive-color="#ccc"
          />
        </van-col>
      </van-row>
      <van-checkbox-group v-model="selectRoom">
        <van-row v-for="item in roomInfo" :key="item.Id">
          <van-col span="22">
            {{ item.RoomTypeName }}-{{ item.RoomNo }}
          </van-col>
          <van-col span="2" style="margin-top: 5px;">
            <van-checkbox :name="item.RoomInfoId" style="margin-top: -3px;" />
          </van-col>
        </van-row>
      </van-checkbox-group>
      <div v-if="type != 3">
        <van-row>
          <van-col span="12" style="color: #999999;font-size: 14px;">
            付款方式
          </van-col>
        </van-row>
        <van-row style="font-size: 13px;">
          <van-col span="8" style="color: #999999;">
            消费金额:<span style="color:red">
              {{ orderInfo.TotalAmount }}
            </span>
          </van-col>
          <van-col span="8" style="color: #999999;">
            已收金额:<span style="color:red">
              {{ orderInfo.AlreadyPayAmount }}
            </span>
          </van-col>
          <van-col span="8" style="color: #999999;">
            待收金额:<span style="color:red">
              {{ orderInfo.NeedToPayAmount }}
            </span>
          </van-col>
        </van-row>
        <!-- <van-field
        label="发票号"
        v-model="InvoiceNumber"
        placeholder="请输入发票号"
        clearable
      /> -->
        <pay
          v-if="orderInfo.NeedToPayAmount"
          ref="pay"
          @submit="onSubmit"
          :money="orderInfo.NeedToPayAmount"
        />
      </div>
      <div v-else-if="type == 3" class="footer-action">
        <van-button
          type="info"
          round
          block
          size="large"
          @click="submitTempLeave"
          >确定</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import orderApi from "../../api/order.js";
import pay from "./Pay";
import { jump } from "../../utils/common";
import {
  Row,
  Col,
  Checkbox,
  CheckboxGroup,
  Button,
  Notify,
  Switch,
  Field,
  Dialog,
} from "vant";

export default {
  name: "OrderCheckOut",
  components: {
    pay,
    [Field.name]: Field,
    [Row.name]: Row,
    [Col.name]: Col,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Button.name]: Button,
    [Switch.name]: Switch,
  },
  data() {
    return {
      orderId: null,
      selectRoom: [], //当前选择的房号资料
      roomInfo: [],
      orderInfo: {},
      payMoney: "",
      checked: true,
      type: "",
      // InvoiceNumber: ""
    };
  },
  model: {},
  created() {
    this.orderId = this.$route.query.id;
    this.type = this.$route.query.type;
    this.init();
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    hanldeSelectRoom() {
      if (this.checked) {
        this.selectRoom = [];
        this.roomInfo.forEach(el => {
          this.selectRoom.push(el.RoomInfoId);
        });
      } else {
        this.selectRoom = [];
      }
    },
    init() {
      orderApi.getOrderDetail({ id: this.orderId }).then(res => {
        this.orderInfo = res.Data;
        // this.roomInfo = res.Data.Details;
        res.Data.Details.forEach(item => {
          if (this.type == 3 && item.OrderStatus == 1) {
            this.roomInfo.push(item);
          } else if (
            this.type != 3 &&
            (item.OrderStatus == 1 || item.OrderStatus == 3)
          ) {
            this.roomInfo.push(item);
          }
        });
        //只有一间房间时默认选中
        // if (this.roomInfo.length == 1) {
        //   this.selectRoom.push(this.roomInfo[0].RoomInfoId);
        // }
        this.roomInfo.forEach(el => {
          this.selectRoom.push(el.RoomInfoId);
        });
      });
    },
    submitTempLeave() {
      //房间暂离
      if (this.selectRoom.length <= 0) {
        Notify("请选择暂离房间");
        return false;
      }
      let rooms = this.roomInfo.filter(item => {
        if (this.selectRoom.includes(item.RoomInfoId)) return item;
      });
      const _this = this;
      Dialog.confirm({
        title: "您确定进行暂离操作吗？",
        message:
          "【暂离】的房间可以另外给其他客人入住，但本订单并未完成，请适时对暂离的房间【办理退房】",
      }).then(() => {
        orderApi
          .tempLeave({
            OrderId: _this.orderId,
            RoomNos: rooms.map(v => v.RoomNo),
          })
          .then(() => {
            Notify({ message: "暂离成功", type: "success" });
            setTimeout(() => {
              jump("OrderDetail", { id: this.orderId });
            }, 500);
          });
      });
    },
    onSubmit(payInfo) {
      if (this.selectRoom.length <= 0) {
        Notify("请选择离店房间");
        return false;
      }
      let rooms = this.roomInfo.map(item => {
        if (this.selectRoom.includes(item.RoomInfoId)) return item;
      });

      payInfo[0].GuestId = rooms[0].Persons[0].Id;
      payInfo[0].OrderId = this.orderId;
      let params = {
        OrderId: this.orderId,
        // InvoiceNumber: this.InvoiceNumber,
        RoomInfoIds: this.selectRoom,
        // PayWays: payInfo
      };
      //1.房间全选 ，无支付金额，且帐平 直接退房 ，如果帐不平，提示信息
      //2.房间不全选 ，无支付金额， 直接退房
      //3.房间全选 ，有支付金额，帐平 先付款，再退房，如果帐不平，提示信息
      //4.房间不全选 ，有支付金额，先付款，再退房
      let amount =
        Number(this.orderInfo.TotalAmount) -
        Number(this.orderInfo.AlreadyPayAmount);
      if (this.selectRoom.length == this.roomInfo.length) {
        //1.房间全选 ，无支付金额，且帐平 直接退房 ，如果帐不平，提示信息
        if (Number(payInfo[0].Money) == 0) {
          if (Number(amount) == 0) {
            //直接退房
            this.settleCheckOut(params);
          } else {
            Notify("待(收/退)金额未支付，不允许退房");
            return false;
          }
        } else {
          //3.房间全选 ，有支付金额，帐平 先付款，再退房，如果帐不平，提示信息
          if (Number(payInfo[0].Money) == Number(amount)) {
            if (!payInfo[0].AccountItemId) {
              Notify("请选择付款方式");
              return false;
            }
            //先付款，再退房
            this.settleCheckOut(params, payInfo);
          } else {
            Notify("所有房退房时，付款金额要等于待(收/退)金额！");
            return false;
          }
        }
      } else {
        //2.房间不全选 ，无支付金额， 直接退房
        if (Number(payInfo[0].Money) == 0) {
          //直接退房
          this.settleCheckOut(params);
        } else {
          //4.房间不全选 ，有支付金额，先付款，再退房
          if (!payInfo[0].AccountItemId) {
            Notify("请选择付款方式");
            return false;
          }
          this.settleCheckOut(params, payInfo);
        }
      }
    },
    //结账离店 isPay(是否需要支付金额)
    settleCheckOut(params, payInfo) {
      if (payInfo) {
        orderApi.addPay(payInfo).then(() => {
          orderApi.settleCheckOut(params).then(() => {
            Notify({ type: "success", message: "退房成功" });
            jump("OrderDetail", { id: this.orderId });
          });
        });
      } else {
        orderApi.settleCheckOut(params).then(() => {
          Notify({ type: "success", message: "退房成功" });
          jump("OrderDetail", { id: this.orderId });
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.van-row {
  padding: 5px 10px;
}
.allSelect {
  text-align: right;
  color: #1989fa;
}
.footer-action {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  padding: 0.13333rem 0.42667rem;
  background-color: #fff;
}
</style>
